/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetEarningStreamsSummaryRequest} from '@cash-web/protos/squareup/cash/paychecks/api/v1/paychecks_app_service.pb'
import {GetEarningStreamsSummaryResponse} from '@cash-web/protos/squareup/cash/paychecks/api/v1/paychecks_app_service.pb'


export const getEarningStreamsSummary = (request: GetEarningStreamsSummaryRequest, options?: CashRequestOptions) => post<GetEarningStreamsSummaryRequest, GetEarningStreamsSummaryResponse>("/2.0/cash/get-earning-streams-summary", request, {...options, rejectOnError: true })